<p-toast></p-toast>
<div class="mat-elevation-z8" *ngIf="this.is_primary_provider">
    <div class="table-responsive text-center justify-content-center" style="
            font-size: 14px;
            margin-bottom: 20px;
            text-align: center;
            vertical-align: center;
        ">
        <p-table [value]="ApprovedDoctors" #dt0 dataKey="id" [rows]="10" [paginator]="true"
            [showCurrentPageReport]="true" [scrollable]="true" [loading]="this.loading"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]='displayedColumns'>
            <ng-template pTemplate="caption">
                <div class="table-header float-right">
                    <div class="ui-table-globalfilter-container">
                        <input type="text" pInputText size="50" placeholder="Search" (input)="
                                dt0.filterGlobal(
                                    $event.target.value,
                                    'contains'
                                )
                            " style="width: 250px; margin-left: 75%" />
                    </div>
                </div>
            </ng-template>

            <ng-template pTemplate="header">
                <tr class="trentry">
                    <th pSortableColumn="created_at">
                        <b>Referred On</b>
                        <p-sortIcon field="created_at"></p-sortIcon>
                    </th>
                    <th pSortableColumn="request_sent_date">
                        <b>Request Sent Date</b>
                        <p-sortIcon field="request_sent_date"></p-sortIcon>
                    </th>
                    <th pSortableColumn="doctor_referred_name">
                        <b>Referred By</b>
                        <p-sortIcon field="doctor_referred_name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="name">
                        <b>Name</b>
                        <p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="specialty_name">
                        <b>Speciality</b>
                        <p-sortIcon field="specialty_name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="country_name">
                        <b>Country</b>
                        <p-sortIcon field="country_name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="state_name">
                        <b>State</b>
                        <p-sortIcon field="state_name"></p-sortIcon>
                    </th>
                    <th style="width: 260px;" pSortableColumn="Doctoremail">
                        <b>Doctor Email</b>
                        <p-sortIcon field="Doctoremail"></p-sortIcon>
                    </th>
                    <th pSortableColumn="contact">
                        <b>Contact</b>
                        <p-sortIcon field="contact"></p-sortIcon>
                    </th>
                    <th pSortableColumn="request_approved_date">
                        <b>Approve Date</b>
                        <p-sortIcon field="request_approved_date"></p-sortIcon>
                    </th>
                    <th pSortableColumn="approved_by_name">
                        <b>Approved By</b>
                        <p-sortIcon field="approved_by_name"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-doctor>
                <tr [pSelectableRow]="doctor" class="trentry">
                    <td>{{ doctor.created_at | date:'medium'}}</td>

                    <td>
                        {{
                        doctor.request_sent_date == null ? "N/A" : (doctor.request_sent_date | date:'medium')
                        }}
                    </td>

                    <td>
                        {{
                            doctor.doctor_referred_name
                        }}
                    </td>

                    <td>{{ doctor.name }}</td>

                    <td>{{ doctor.specialty_name == null || doctor.specialty_name == "" ? "N/A" : doctor.specialty_name }}</td>

                    <td>{{ doctor.country_name }}</td>

                    <td>{{ doctor.state_name }}</td>

                    <td style="width: 260px;word-break: break-all;">{{ doctor.Doctoremail }}</td>

                    <td>{{ doctor.contact }}</td>

                    <td>{{ doctor.request_approved_date | date:'medium' }}</td>

                    <td>{{ doctor.approved_by_name }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<div class="mat-elevation-z8">
    <div class="table-responsive text-center justify-content-center" style="
            font-size: 14px;
            margin-bottom: 20px;
            text-align: center;
            vertical-align: center;
        ">
        <p-table [value]="DoctorsRoles" #dt1 dataKey="id" [rows]="10" [paginator]="true" [showCurrentPageReport]="true"
            [scrollable]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [loading]="this.loading1" [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]='displayedColumnsTwo'>
            <ng-template pTemplate="caption">
                <div class="table-header float-right">
                    <div class="ui-table-globalfilter-container">
                        <input type="text" pInputText size="50" placeholder="Search" (input)="
                                dt1.filterGlobal(
                                    $event.target.value,
                                    'contains'
                                )
                            " style="width: 250px; margin-left: 75%" />
                    </div>
                </div>
            </ng-template>


            <ng-template pTemplate="header">
                <tr class="trentry">
                    <th style="width: 100px;" pSortableColumn="sr_no">
                        <b>Sr No</b>
                        <p-sortIcon field="sr_no"></p-sortIcon>
                    </th>
                    <th style="width: 100px;">
                        <b>Profile View</b>
                    </th>
                    <ng-container *ngIf="this.login_role==3 || this.login_role==4">
                        <th style="width: 100px;">
                            <b>Profile Edit</b>
                        </th>
                    </ng-container>
                    <th pSortableColumn="role">
                        <b>Role</b>
                        <p-sortIcon field="role"></p-sortIcon>
                    </th>
                    <th pSortableColumn="featured_doctor_id" *ngIf="this.is_primary_provider">
                        <b>Featured on homepage</b>
                        <p-sortIcon field="featured_doctor_id"></p-sortIcon>
                    </th>
                    <th pSortableColumn="name" style="width: 200px;" *ngIf="this.is_primary_provider"><b>Edit Role</b></th>
                    <th pSortableColumn="name">
                        <b>Doctor Name</b>
                        <p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="specialty_name">
                        <b>Specialty</b>
                        <p-sortIcon field="specialty_name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="country_name">
                        <b>Country</b>
                        <p-sortIcon field="country_name"></p-sortIcon>
                    </th>
                    <!-- <th pSortableColumn="state_name">
                        <b>State</b>
                        <p-sortIcon field="state_name"></p-sortIcon>
                    </th> -->

                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-doctorroles>
                <tr [pSelectableRow]="doctorroles" class="trentry">
                    <td style="width: 100px;">{{ doctorroles.sr_no }}</td>
                    <td style="width: 100px;">
                        <button pButton class="btn btn-danger btn-sm btn-space"
                            (click)="DoctorProfileDialog(true,doctorroles.doctor_user_guid)" type="button"
                            label="View"></button>
                    </td>
                    <ng-container *ngIf="this.login_role==3 || this.login_role==4">
                        <td style="width: 100px;">
                            <button pButton class="btn btn-danger btn-sm btn-space"
                                (click)="gotoEditProfile(doctorroles.doctor_user_guid)" type="button"
                                label="Edit"></button>
                        </td>
                    </ng-container>
                    <td *ngIf="this.is_primary_provider">
                        <div *ngIf="selected_user_guid!=doctorroles.doctor_user_guid">{{ doctorroles.role }}</div>
                        <div *ngIf="selected_user_guid==doctorroles.doctor_user_guid">
                            <p-dropdown [options]="Roles" [(ngModel)]="SelectedRole" [disabled]="this.posting"
                                [style]="{'width':'100%','min-width':'100%'}" placeholder="Select a Role"
                                tooltipPosition="bottom" optionLabel="label" [showClear]="true"></p-dropdown>
                        </div>

                    </td>
                    <td *ngIf="this.is_primary_provider">
                        <div *ngIf="selected_user_guid!=doctorroles.doctor_user_guid">
                            {{ doctorroles.featured_doctor_id?"Featured":"Not Featured" }}</div>
                        <div *ngIf="selected_user_guid==doctorroles.doctor_user_guid">
                            <p-dropdown [options]="featured_option" [style]="{'width':'100%','min-width':'100%'}"
                                [disabled]="this.posting" [(ngModel)]="selected_doctor_featured"
                                placeholder="Show on homepage?" tooltipPosition="bottom" optionLabel="label"
                                [showClear]="true"></p-dropdown>
                        </div>

                    </td>
                    <td style="width: 200px;">
                        <button *ngIf="selected_user_guid!=doctorroles.doctor_user_guid" pButton type="button"
                            label="Edit" [disabled]="this.posting" (click)="EnableRoleChange(doctorroles)"></button>
                        <button *ngIf="selected_user_guid==doctorroles.doctor_user_guid" pButton type="submit"
                            [disabled]="this.posting" label="Update"
                            [disabled]="selected_doctor_featured==null || SelectedRole==null"
                            style="margin-bottom:10px;margin-right:5px;" (click)="showConfirmationDialog()"></button>

                        <button *ngIf="selected_user_guid==doctorroles.doctor_user_guid" pButton type="button"
                            [disabled]="this.posting" label="Cancel" style="margin-bottom:10px;margin-right:5px;"
                            (click)="CancelRoleChange()"></button>

                    </td>

                    <td>{{ doctorroles.name}}</td>

                    <td>{{ doctorroles.specialty_name }}</td>

                    <td>{{ doctorroles.country_name }}</td>

                </tr>
            </ng-template>
        </p-table>
        <p-dialog header="Update Confirmation" [(visible)]="display" (onHide)="CancelRoleChange()">
            <p>Are you sure you want to update Role/Featured on Homepage</p>
            <p-footer>
                <button pButton type="button" class="ui-button-success" label="Yes" icon="pi pi-save"
                    (click)="ChangeRoles()"></button>
                <button pButton type="button" class="ui-button-warning" label="No" icon="pi pi-times"
                    (click)="CancelRoleChange()"></button>
            </p-footer>
        </p-dialog>

    </div>
</div>

<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="this.table_response?.success!=null && this.table_response?.success==false">
    <p *ngIf="this.table_response?.error!=null">{{this.table_response?.error?.message}}</p>
    <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode!=500">
        <p *ngFor="let message of this.table_serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="this.table_serverError?.error!=null && this.table_serverError?.statusCode==500">
        <p>{{this.table_serverError?.message}}</p>
    </div>

</div>

<div *ngIf="DoctorProfileVar">
    <p-dialog header="Doctor Profile" [resizable]="false" responsive="true" (onHide)="DoctorProfileDialog(false,null)"
        [(visible)]="DoctorProfileVar">
        <app-doctorprofile [user_guid]="user_guid"></app-doctorprofile>
    </p-dialog>
</div>
